<template>
  <header>
    <ul class="clearfix" :class="{ maxWidth: loginStatus }">
      <li class="fl">
        <!-- 登入後 顯示 -->
        <img
          src="@/assets/images/header/scroll_black.png"
          class="header_btn"
          id="menu_open_button"
          @click="openMenu"
          v-show="loginStatus && matches"
          data-testid="header_btn"
        />

        <!-- login page 顯示 -->
        <div v-show="!loginStatus">
          <router-link to="/home" class="logo" data-testid="goToHome">
            <img class="logoImg" />
          </router-link>
        </div>
      </li>
      <!-- 登入顯示 -->
      <!-- <li class="ib_radio" v-show="isIb">
        <el-radio-group v-model="ibButton" data-testid="goToIbPortal">
          <el-radio-button label="Client"></el-radio-button>
          <el-radio-button label="IB"></el-radio-button>
        </el-radio-group>
      </li> -->
      <li class="ib_radio" v-show="isIb">
        <PortalSwitch @click="goToIbPortal"></PortalSwitch>
      </li>
      <li class="fr header_menu" v-show="loginStatus">
        <el-dropdown trigger="click" @command="handleCommand" @visible-change="addStyle" data-testid="dropdown">
          <div class="login_inner">
            <img v-if="openImg" src="@/assets/images/header/header_black.png" alt class="member_logo" />
            <img v-else src="@/assets/images/header/header_icon.png" alt class="member_logo" />
          </div>
          <!-- logout_icon -->
          <el-dropdown-menu slot="dropdown" class="login_dropdown_box">
            <div class="dropdown_username">{{ userName }}</div>
            <div class="dropdown_username cursor-pointer" @click="onCopy">
              {{ userId }}
              <svg-icon iconName="copy-icon" style="width: 12px; height: 12px"></svg-icon>
            </div>
            <el-dropdown-item command="verificationStatus" class="verification_status">
              <div class="icon"></div>
              <span>{{ $t('menu.verificationStatus') }}</span>
              <span v-if="!(accountAuditStatus === auditStatus.completed && idPass && poaPass)" class="continue_tag">{{
                $t('common.button.continue')
              }}</span>
            </el-dropdown-item>
            <el-dropdown-item command="logout" class="logout" data-testid="logout">
              <div class="icon"></div>
              <span>{{ $t('common.button.logout') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>

      <MobileAvatar
        v-if="isMobile"
        v-show="showHeader"
        style="margin: 0 9px"
        :isIb="isIb"
        :userName="userName"
        :userId="userId"
        :showLang="showLang"
        :lang="lang"
        :language="language"
        :languages="languages"
        @onLanguageChange="langCommand"
        @click="goToIbPortal"
        @onLogout="logout"
        ref="mobileMenu"
      >
      </MobileAvatar>
      <!-- 通知 -->
      <li class="notification">
        <HeaderNotification @readGuide="readGuide"></HeaderNotification>
      </li>
      <li class="flag" :class="{ flagLogin: loginStatus, forceShow: !showHeader }" v-show="showLang">
        <el-dropdown id="lang" trigger="click" :hide-on-click="false" @command="langCommand" data-testid="dropdownFlag">
          <img class="areaImg" :src="language.icon" alt />
          <el-dropdown-menu slot="dropdown" class="lang_dropdown_box" placement="right-end">
            <el-dropdown-item
              v-for="item in languages"
              :key="item.value"
              :command="item"
              :class="{ active: lang == item.value }"
              :data-testid="item.value"
            >
              <img :src="item.icon" />
              <span>{{ item.label }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
      <li id="header_guide" class="deposit" v-show="showHeader">
        <div class="blue_button deposit_btn" @click="goDeposit">
          {{ $t('deposit.default.deposit') }}
        </div>
      </li>
      <li class="deposit" v-show="showHeader && showHeaderTrader">
        <div v-if="isMobile" class="blue_button deposit_btn" @click="goWebtrader">
          {{ $t('common.button.webtrader') }}
        </div>
        <div v-else class="blue_button deposit_btn" @click="goWebtrader">{{ $t('common.button.tradeOn') }}</div>
      </li>
    </ul>
  </header>
</template>

<script>
import HeaderNotification from '@/components/notification/HeaderNotification';
import helper from '@/util/signinHelper';
import isMobile from '@/mixins/isMobile';
import MobileAvatar from '@/components/template/header/MobileAvatar.vue';
import PortalSwitch from '@/components/template/header/PortalSwitch.vue';
import { mapGetters, mapState } from 'vuex';
import auditStatus from '@/constants/auditStatus';
import { RegisterRoutePath } from '@/router/registerRoutes';
import { sensorsRegister } from '@/util/sensorsdata';
import { RTL_LANGUAGE_LIST } from '@/constants/language.js';
import { setLocale } from '@/util/i18n';
import ClipboardCopy from '@/components/clipboard-copy/ClipboardCopy.vue';

export default {
  name: 'vHeader',
  mixins: [isMobile],
  props: {
    matches: Boolean
  },
  components: {
    HeaderNotification,
    MobileAvatar,
    PortalSwitch,
    ClipboardCopy
  },
  data() {
    return {
      isIb: false,
      showLang: true,
      showHeader: true,
      showHeaderTrader: true,
      language: '',
      languages: [
        {
          value: 'en_US',
          label: 'English',
          icon: require('@/assets/images/flag/uk_flag.png')
        },
        {
          value: 'zh_CN',
          label: '中文简体',
          icon: require('@/assets/images/flag/cn_flag.png')
        },
        {
          value: 'zh_TW',
          label: '中文繁體',
          icon: require('@/assets/images/flag/hk_flag.png')
        },
        {
          value: 'fr_FR',
          label: 'Français',
          icon: require('@/assets/images/flag/fr_flag.png')
        },
        {
          value: 'ko',
          label: '한국어',
          icon: require('@/assets/images/flag/ko_flag.png')
        },
        {
          value: 'ja',
          label: '日本語',
          icon: require('@/assets/images/flag/ja_flag.png')
        },
        {
          value: 'th',
          label: 'ภาษาไทย',
          icon: require('@/assets/images/flag/th_flag.png')
        },
        {
          value: 'vi',
          label: 'Tiếng Việt',
          icon: require('@/assets/images/flag/vi_flag.png')
        },
        {
          value: 'es',
          label: 'Español',
          icon: require('@/assets/images/flag/es_flag.png')
        },
        {
          value: 'pt',
          label: 'Português',
          icon: require('@/assets/images/flag/pt_flag.png')
        },
        {
          value: 'de',
          label: 'Deutsch',
          icon: require('@/assets/images/flag/de_flag.png')
        },
        {
          value: 'id',
          label: 'Indonesian',
          icon: require('@/assets/images/flag/id_flag.png')
        },
        {
          value: 'ar',
          label: 'عربي',
          icon: require('@/assets/images/flag/ar_flag.png')
        },
        {
          value: 'pl',
          label: 'Polski',
          icon: require('@/assets/images/flag/pl_flag.png')
        },
        {
          value: 'it',
          label: 'Italian',
          icon: require('@/assets/images/flag/it_flag.png')
        },
        {
          value: 'fa',
          label: 'فارسی',
          icon: require('@/assets/images/flag/fa_flag.png')
        },
        {
          value: 'hi',
          label: 'हिंदी',
          icon: require('@/assets/images/flag/hi_flag.png')
        },
        {
          value: 'ru',
          label: 'Русский',
          icon: require('@/assets/images/flag/ru_flag.png')
        }
      ],
      specificUrlLanguageSetting: [
        {
          url: 'myaccount.vtmarketsindo.com',
          lang: 'id'
        }
      ],
      openImg: false,
      hostName: location.hostname,
      ibButton: 'Client'
    };
  },
  watch: {
    loginStatus(loginStatus) {
      if (loginStatus) {
        this.getUserInfo();
      } else {
        this.autoChangeLangByHostName();
      }
    },
    language(lang) {
      this.lang = lang.value;
    },
    lang: {
      immediate: true,
      handler(val) {
        setLocale(val);
        document.body.dir = RTL_LANGUAGE_LIST.includes(val) ? 'rtl' : 'ltr';
        // 如果找不到預設第一筆
        this.language = this.languages.find(f => f.value == val) || this.languages[0];
        this.setFontFamily(val);
        sensorsRegister({ current_lang: val });
        try {
          zE('messenger:set', 'locale', this.$options.filters.zendeskLangSwitch(val));
        } catch (error) {
          console.log('zendesk not found', error);
        }
      }
    },
    $route: {
      handler(route) {
        this.showLang = route.meta.restrictLang ? false : true;
        this.showHeader = route.meta.showDepositHeader ? false : true;
        this.showHeaderTrader = route.meta.notShowDepositHeader ? false : true;
      },
      immediate: true
    },
    ibButton(newVal) {
      if (newVal === 'IB') {
        this.$redirect.redirectToIbPortal();
      }
    }
  },
  computed: {
    userName() {
      return this.$store.state.common.userName;
    },
    userId() {
      return this.$store.state.common.userId;
    },
    loginStatus() {
      return this.$store.state.common.loginStatus;
    },
    userType() {
      return this.$store.state.common.userType;
    },
    lang: {
      get() {
        return this.$store.state.common.lang;
      },
      set(value) {
        return this.$store.commit('common/setLang', value);
      }
    },
    isWantAutoSetLangByHostName: {
      get() {
        return sessionStorage.getItem('isWantAutoSetLangByHostName');
      },
      set(value) {
        return sessionStorage.setItem('isWantAutoSetLangByHostName', value);
      }
    },
    ...mapState('common', ['openAccountEnabled', 'accountAuditStatus']),
    ...mapGetters('common', ['idPass', 'poaPass'])
  },
  methods: {
    onCopy(e) {
      this.$message({
        message: this.$t('common.message.copied'),
        type: 'success'
      });
      navigator.clipboard.writeText(this.userId);
    },
    addStyle(bool) {
      this.openImg = bool;
    },
    openMenu() {
      this.$emit('openMenu');
      this.$refs.mobileMenu.onMaskClose();
    },
    logout() {
      helper.signOut(null, 'manually');
      this.isWantAutoLangByHostName = true;
    },
    handleCommand(command) {
      if (command == 'logout') this.logout();
      else if (command == 'verificationStatus') this.redirectVerification();
    },
    langCommand(command) {
      this.language = command;
      //see if language is changed in the landing page
      if (!this.loginStatus) {
        this.$store.commit('common/setIsChangedLangAtLandingPage', true);
      }
    },
    getUserInfo() {
      this.isIb = this.userType === 5 || this.userType === 16 ? true : false;
    },
    setFontFamily(lang) {
      if (lang == 'ja') {
        document.body.style.setProperty('font-family', 'NotoSansCJKJapanese', 'important');
      } else if (lang == 'zh_CN' || lang == 'zh_TW') {
        document.body.style.setProperty('font-family', 'NotoSansCJKSimChinese', 'important');
      } else if (lang == 'ko') {
        document.body.style.setProperty('font-family', 'NotoSansCJKKorean', 'important');
      } else if (lang == 'vi') {
        document.body.style.setProperty('font-family', 'NotoSansRegular', 'important');
      } else {
        document.body.style.setProperty('font-family', 'Oblivian', 'important');
      }
    },
    autoChangeLangByHostName() {
      if (this.hostName.includes('myaccount.vtmarketsiq.com')) {
        // Follow browser language
        const lang = this.getBrowserLanguage();
        const language = this.languages.find(langObj => langObj.value.split('_')[0] === lang);
        if (language) {
          this.langCommand(language);
        }
      } else {
        for (const { lang, url } of this.specificUrlLanguageSetting) {
          if (this.hostName.includes(url)) {
            const language = this.languages.find(langObj => langObj.value === lang);
            this.langCommand(language);
          }
        }
      }
    },
    getBrowserLanguage() {
      const language = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
      // Return only the language code (en)
      return language.split('-')[0];
    },
    goDeposit() {
      this.$router.push({ path: '/depositFunds' });
    },
    redirectVerification() {
      this.$router.push(RegisterRoutePath.register);
    },
    goToIbPortal() {
      this.$redirect.redirectToIbPortal();
    },
    readGuide() {
      this.$emit('readGuide', 'fromBanner');
    },
    goWebtrader() {
      window.open('https://protrader.vtms.live/', '_blank');
    }
  },
  created() {
    this.auditStatus = auditStatus;
  },
  mounted() {
    //for already logged-in users
    if (this.loginStatus) {
      this.getUserInfo();
    } else {
      if (this.isWantAutoSetLangByHostName === 'true' || this.isWantAutoSetLangByHostName === null) {
        this.autoChangeLangByHostName();
        this.isWantAutoSetLangByHostName = false;
      }
    }

    onbeforeunload = () => {
      this.isWantAutoSetLangByHostName = true;
    };

    let callback = (val, oldVal, uri) => {
      console.log('localStorage change', val);
      if (val != this.userName) location.reload();
    };

    this.$ls.on('setUserName', callback); //watch change foo key and triggered callback
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/layout/header.scss';
</style>
